// eslint-disable-next-line max-classes-per-file
import { Quill } from 'vue2-editor';

const InlineBlot = Quill.import('blots/block');
const BlockEmbed = Quill.import('blots/block/embed');

export class LoadingImage extends InlineBlot {
  static create(src: any) {
    const node = super.create(src);
    if (src === true) return node;

    const image = document.createElement('img');
    image.setAttribute('src', src);
    node.appendChild(image);
    return node;
  }

  deleteAt(index: number, length: string) {
    super.deleteAt(index, length);
    this.cache = {};
  }

  static value(domNode: any) {
    const { src, custom } = domNode.dataset;
    return { src, custom };
  }
}

LoadingImage.blotName = 'imageBlot';
LoadingImage.className = 'image-uploading';
LoadingImage.tagName = 'span';

Quill.register({ 'formats/imageBlot': LoadingImage });

export class ImageBlot extends BlockEmbed {
  static create(value: any) {
    const node = super.create();
    node.setAttribute('src', value);
    node.setAttribute('loading', 'lazy');
    return node;
  }

  static value(node: any) {
    return {
      url: node.getAttribute('src'),
      loading: node.getAttribute('loading'),
    };
  }
}
